import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://menunix-admin-672430011112.asia-south1.run.app';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('agent');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  googleLogin: async (token) => {
    const response = await api.post('/auth/google', { token });
    return response.data;
  },
};

// Shop API
export const shopAPI = {
  getShops: async () => {
    const response = await api.get('/shops');
    return response.data;
  },
  createShop: async (shopData) => {
    const response = await api.post('/shops', shopData);
    return response.data;
  },
  updateShop: async (shopId, shopData) => {
    const response = await api.put(`/shops/${shopId}`, shopData);
    return response.data;
  },
};

// Product API
export const productAPI = {
  getProducts: async (shopId) => {
    const response = await api.get(`/products/${shopId}`);
    return response.data;
  },
};

// Table API
export const tableAPI = {
  getTables: async (shopId) => {
    const response = await api.get(`/tables/${shopId}`);
    return response.data;
  },
};

// Category API
export const categoryAPI = {
  getCategories: async (shopId) => {
    const response = await api.get(`/categories/${shopId}`);
    return response.data;
  },
};

// Shop Owner API
export const shopOwnerAPI = {
  getShopOwners: async (shopId) => {
    const response = await api.get(`/shop-owners/${shopId}`);
    return response.data;
  },
  createShopOwner: async (shopId, ownerData) => {
    const response = await api.post(`/shop-owners/${shopId}`, ownerData);
    return response.data;
  },
  updateShopOwner: async (shopId, ownerId, ownerData) => {
    const response = await api.put(`/shop-owners/${shopId}/${ownerId}`, ownerData);
    return response.data;
  },
  deleteShopOwner: async (shopId, ownerId) => {
    const response = await api.delete(`/shop-owners/${shopId}/${ownerId}`);
    return response.data;
  },
};

// Menu Upload API
export const menuUploadAPI = {
  uploadMenuImage: async (shopId, formData) => {
    const token = localStorage.getItem('token');
    // For file uploads, use axios directly with custom config
    // Don't set Content-Type - browser will set it with boundary for multipart/form-data
    const response = await axios.post(
      `${API_URL}/menu/upload/${shopId}`,
      formData,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          // Let axios/browser set Content-Type automatically for FormData
        },
      }
    );
    return response.data;
  },
};

// Agent API
export const agentAPI = {
  getAgents: async () => {
    const response = await api.get('/agents');
    return response.data;
  },
  updateAgent: async (agentId, agentData) => {
    const response = await api.put(`/agents/${agentId}`, agentData);
    return response.data;
  },
};

export default api;

